import { render, staticRenderFns } from "./FreeAccount.vue?vue&type=template&id=90707628&scoped=true&"
import script from "./FreeAccount.vue?vue&type=script&lang=js&"
export * from "./FreeAccount.vue?vue&type=script&lang=js&"
import style0 from "./FreeAccount.vue?vue&type=style&index=0&id=90707628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90707628",
  null
  
)

export default component.exports